import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Header, Sidebar } from "../Layout";
import PartnerDashbord from "./PartnerDashboard";
import ProjectDashboard from "./ProjectDashboard";
import ReportDashboard from "./ReportDashboard";
import ShortcutsDashbord from "./ShortcutsDashboard";
import { getuserDashboardData } from "../../actions/userDashboardAction";
import { getPartners } from "../../actions/partnerActions";
import { MEMBER } from '../../constants/constants';

const Dashboard = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const { projects, shortcuts, partners} = useSelector(state => state.userDashboardStore);
    // const { partners } = useSelector(state => state.partnerStore);


    useEffect(() => {
        dispatch(getuserDashboardData());
        dispatch(getPartners());
    }, [dispatch])

    const refreshProjectList = () => {
        dispatch(getuserDashboardData())
    }

    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Dashboard</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="index.html"><i className="icon-home"></i></a></li>
                                <li className="breadcrumb-item active">Dashboard</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix mb-3">
                        <div className="col-lg-12">
                            <h2 className="text_bold">Welcome, {user?.name}</h2>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <ShortcutsDashbord shortcuts={shortcuts} refreshProject={refreshProjectList} />
                        <ProjectDashboard projects={projects} refreshProject={refreshProjectList} />
                        {user.userType === MEMBER ? null : <PartnerDashbord partners={partners} />}
                        <ReportDashboard />

                    </div>
                </div>
            </div>

        </>

    );
}

export default Dashboard;
